export default "__VITE_ASSET__CHKeChsJ__"